import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
    fetchAllBrands,
    fetchAllBrandsStart,
    fetchAllBrandsSuccess,
    fetchAllBrandsFailure,
    fetchBrandById,
    fetchBrandByIdStart,
    fetchBrandByIdSuccess,
    fetchBrandByIdFailure,
    onboardBrand,
    onboardBrandStart,
    onboardBrandSuccess,
    onboardBrandFailure,
    FetchAllBrandsParams,
} from "../slices/brandsSlice";
import { makeRequest } from "../../utils/api";
import { Brand, BrandsPaginatedResponse, OnboardBrandForm } from "../../types/pages/onboarding";
import { extractErrorMessage } from "../../utils/helpers";

function* fetchAllBrandsSaga(
    action: PayloadAction<FetchAllBrandsParams>
): Generator<any, void, any> {
    try {
        yield put(fetchAllBrandsStart());
        const { page, rowsPerPage, sortBy = "created_at", sortOrder = -1 } = action.payload;
        const skip = page * rowsPerPage;
        const response: BrandsPaginatedResponse = yield call(
            makeRequest,
            "get",
            `/organizations/all-organizations?skip=${skip}&limit=${rowsPerPage}&sort_by=${sortBy}&sort_order=${sortOrder}`
        );
        yield put(fetchAllBrandsSuccess(response));
    } catch (error: any) {
        yield put(fetchAllBrandsFailure(extractErrorMessage(error)));
    }
}

function* fetchBrandByIdSaga(
    action: PayloadAction<string>
): Generator<any, void, any> {
    try {
        yield put(fetchBrandByIdStart());
        const response: Brand = yield call(
            makeRequest,
            "get",
            `/organizations/${action.payload}`
        );
        yield put(fetchBrandByIdSuccess(response));
    } catch (error: any) {
        yield put(fetchBrandByIdFailure(extractErrorMessage(error)));
    }
}

function* onboardBrandSaga(
    action: PayloadAction<OnboardBrandForm>
): Generator<any, void, any> {
    try {
        yield put(onboardBrandStart());
        const { brand_name, name, logo, support_email, customer_care, website, billing_address, contact, country, first_name, last_name, email, password } = action.payload;
        const payload = {
            organization: { brand_name, name, logo, support_email, customer_care, website, billing_address, contact, country },
            owner: { first_name, last_name, email, password },
        };
        yield call(makeRequest, "post", "/organizations/on-boarding", payload);
        yield put(onboardBrandSuccess());
        toast.success(`Brand "${brand_name}" has been onboarded successfully!`);
    } catch (error: any) {
        const message = extractErrorMessage(error);
        yield put(onboardBrandFailure(message));
        toast.error(message || "Failed to onboard brand. Please try again.");
    }
}

export default function* brandsSaga(): Generator<any, void, any> {
    yield takeLatest(fetchAllBrands.type, fetchAllBrandsSaga);
    yield takeLatest(fetchBrandById.type, fetchBrandByIdSaga);
    yield takeLatest(onboardBrand.type, onboardBrandSaga);
}
